import { Fragment } from 'react';
import { HtmlStringToReact } from 'app/domains/global-search/components/HtmlStringToReact';
import { getSearchHighlightContext } from 'app/domains/global-search/utils/getSearchHighlightContext';
import { StyledText } from './styled';
export function Match(props) {
    const { name, highlight } = props;
    const { highlightText, showNameOnly } = getSearchHighlightContext(name, highlight);
    return showNameOnly ? (<StyledText $fontSize="small">
      <HtmlStringToReact allowedTags={['mark']} text={highlightText}/>
    </StyledText>) : (<Fragment>
      <StyledText $fontSize="small">{name}</StyledText>
      <StyledText $appearance="200" $fontSize="tiny">
        … <HtmlStringToReact allowedTags={['mark']} text={highlightText}/> …
      </StyledText>
    </Fragment>);
}
